(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsCustomerCampaignResponseController', reports);

  reports.$inject = ['$scope', 'NotificationService', 'LangService', 'MailingCampaignService', '$http'];

  function reports ($scope, NotificationService, LangService, MailingCampaignService, $http) {
    var vmRCustomerCampaignResponse = this;

    vmRCustomerCampaignResponse.campaigns = [];

    	$scope.vmRCustomerCampaignResponse = vmRCustomerCampaignResponse;

    vmRCustomerCampaignResponse.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    LangService
      .getPageLabels({ 'page': 'menu.reports.customerCampaignResponse' })
      .$promise
      .then(function (data) {
        vmRCustomerCampaignResponse.labels = data.lang;
      });

    MailingCampaignService
      .get()
      .$promise
      .then(function (obj) {
        vmRCustomerCampaignResponse.campaigns = obj.data;
      })
      .catch(function (error) {
        errorHandler(error, $scope.labels.errorLoadCamp);
      });

    vmRCustomerCampaignResponse.generate = function () {
      vmRCustomerCampaignResponse.loading = true;
      $http.get(apiUrl + '/reports/customer_campaign_response', {
        params: {
          filters: vmRCustomerCampaignResponse.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          vmRCustomerCampaignResponse.loading = false;
          if (data.success === false) {
            NotificationService.warningHandler(data, data.error_message);
            return;
          }

          if (data.indexOf('no_records') >= 0) {
            NotificationService.warningHandler(data, vmRCustomerCampaignResponse.labels.noRecordsFound);
            return;
          }

          if (data) {
            var filename = headers('Mktzap-Filename') || vmRCustomerCampaignResponse.labels.fileName + '.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: headers('Content-type') });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          } else {
            NotificationService.warningHandler(data, vmRCustomerCampaignResponse.labels.noRecordsFound);
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, $scope.labels.errorReport);
        })
    }
  }
})();
